/** Details sahifalaridagi "yorliq + qiymat" juftligi. */
export const InfoField = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <div className="flex flex-col gap-1">
    <span className="text-xs font-normal text-foreground opacity-50">
      {label}
    </span>
    {children}
  </div>
);
